import { DataGridBody, DataGridCell, DataGridRow } from '@twilio-paste/core/data-grid';

import { AppModel } from '../../../modules/Apps';

import { AppsTableActions } from './AppsTableActions/AppsTableActions';
import { AppsTableStatus } from './AppsTableStatus';

interface AppsTableBodyProps {
  apps: AppModel[];
}

export function AppsTableBody({ apps }: AppsTableBodyProps) {
  return (
    <DataGridBody>
      {apps.map(app => (
        <DataGridRow key={app.appId}>
          <DataGridCell>{app.name}</DataGridCell>
          <DataGridCell>{app.appId}</DataGridCell>
          <DataGridCell>{app.code}</DataGridCell>
          <DataGridCell>
            <AppsTableStatus status={app.status} />
          </DataGridCell>
          <DataGridCell>
            <AppsTableActions app={app} />
          </DataGridCell>
        </DataGridRow>
      ))}
    </DataGridBody>
  );
}
